import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import { primaryRiskColorStyles, secondaryRiskColorStyles } from '../../styles';
import { Risk } from '../../types';
import VeraLabel from './vera-label';

export interface Props {
  className?: string;
  score: number;
  risk: Risk;
}

class VeraScoreLabel extends React.Component<Props> {
  public static defaultProps: Props = {
    risk: 'at-risk',
    score: 0,
  };

  public render() {
    const { className, risk, score = '' } = this.props;
    return (
      <VeraLabel className={`${className} risk-${risk}`}>{score}</VeraLabel>
    );
  }
}

export default styled(VeraScoreLabel)`
  border-width: 1px;
  border-style: solid;
  ${primaryRiskColorStyles('color', '&')};
  ${primaryRiskColorStyles('border-color', '&')};
`;
